import { useEffect } from 'react';
import type { ProjectType } from '@jira/platform__project-types/src/project-types.tsx';
import { SERVICE_DESK_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { useJswOnboarding } from '@atlassian/jira-onboarding-quickstart-core/src/services/index.tsx';

export const useRefreshOnJSMProjectSwitch = (
	projectId: number | undefined,
	projectType: ProjectType | undefined,
): void => {
	const [, { resetIsQuickstartLoaded }] = useJswOnboarding();
	useEffect(() => {
		if (projectType === SERVICE_DESK_PROJECT) {
			resetIsQuickstartLoaded();
		}
	}, [resetIsQuickstartLoaded, projectId, projectType]);
};
